import React from 'react';
import { Divider } from 'antd';

const Div = ({ value }) => <Divider>{value}</Divider>;

export default Div;
